import { render, staticRenderFns } from "./ControlloQualitaCristal.vue?vue&type=template&id=620c36d6&scoped=true&"
import script from "./ControlloQualitaCristal.vue?vue&type=script&lang=js&"
export * from "./ControlloQualitaCristal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c36d6",
  null
  
)

export default component.exports